import type {RouterConfig} from '@nuxt/schema'
import {routes} from '~/router'

export default <RouterConfig>{
    // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
    routes: () => routes,
}
